module.exports = __webpack_public_path__ + "img/houdinis-strange-tales.3cca09d.jpeg";